import { render } from 'react-dom'
import React, { useState, useEffect, useCallback } from 'react'
import { useTransition, animated, config } from 'react-spring'
import ReactDOM from 'react-dom';
import AbsoluteWrapper from "./AbsoluteWrapper";
import Cards1 from "./Cards_1";
import Cards2 from "./Cards_2";
import Cards3 from "./Cards_3";
import Cards4 from "./Cards_4";
import Cards5 from "./Cards_5";
import Cards6 from "./Cards_6";
import Cards7 from "./Cards_7";
import Cards8 from "./Cards_8";
import usePrevious from './use-previous';



//For us to allow you to reset your password, we need to first confirm your identity. Please enter your username and date of birth. 


const slides = [
  /*{ id: 0, url: 'photo-1544511916-0148ccdeb877?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1901&q=80i' },
  { id: 1, url: 'photo-1544572571-ab94fd872ce4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1534&q=80' },
  { id: 2, url: 'reserve/bnW1TuTV2YGcoh1HyWNQ_IMG_0207.JPG?ixlib=rb-1.2.1&w=1534&q=80' },
  { id: 3, url: 'photo-1540206395-68808572332f?ixlib=rb-1.2.1&w=1181&q=80' },*/
 /* { id: 0, url: './pictures/images_0.jpg' },
  { id: 1, url: './pictures/images_1.jpg' },
  { id: 2, url: './pictures/images_2.jpg' },
  { id: 3, url: './pictures/images_3.jpg' },
  { id: 4, url: './pictures/images_4.jpg' },
  { id: 5, url: './pictures/images_5.jpg' },
  { id: 6, url: './pictures/images_6.jpg' },*/
  //{ id: 7, url: './pictures/images_7.jpg' },
  //{ id: 8, url: './pictures/images_8.jpg' },
  { id: 17, url: './pictures/images_17.jpg' },

  { id: 11, url: './pictures/MainTable.PNG' },
  
  { id: 10, url: './pictures/images_10.jpg' },

  

  { id: 12, url: './pictures/images_29.png' },
  { id: 13, url: './pictures/images_12.jpg' },
  { id: 14, url: './pictures/images_13.jpg' },
  { id: 15, url: './pictures/images_14.jpg' },
  { id: 16, url: './pictures/images_15.jpg' },

  { id: 16, url: './pictures/images_16.jpg' },
  { id: 17, url: './pictures/images_17.jpg' },
  { id: 18, url: './pictures/images_18.jpg' },
  //{ id: 19, url: './pictures/images_19.jpg' },
  { id: 20, url: './pictures/images_20.jpg' },
  { id: 21, url: './pictures/images_21.jpg' },
  { id: 22, url: './pictures/images_22.jpg' },
  { id: 23, url: './pictures/images_23.jpg' },
  { id: 24, url: './pictures/images_24.jpg' },
  { id: 25, url: './pictures/images_25.jpg' },
  { id: 26, url: './pictures/images_26.jpg' },
  { id: 27, url: './pictures/images_27.jpg' },
  { id: 28, url: './pictures/images_28.jpg' },
  { id: 29, url: './pictures/images_29.jpg' },
  { id: 30, url: './pictures/images_30.jpg' },

]



const MainApp = () => {

  // State value and setter for our example
  const [count, setCount] = useState(0);

  // Get the previous value (was passed into hook on last render)
  const prevCount = usePrevious(count);

  const [index, set] = useState(0)

  const onClick = useCallback(() => set(state => (state + 1) % 3), [])

  const transitions = useTransition(slides[index], item => item.id, {
    //from: { opacity: 0, transform: "translate(-50%, -50%)" },
    from: { opacity: 0, transform: "translate(100%, 0)" },
    enter: { opacity: 1, transform: "translate(-1%, 0)" },
    leave: { opacity: 0, transform: "translate(-50%, 0)" },
    config: config.molasses,
  })

  useEffect(() => void setInterval(() => set(state => (state + 1) % 4), 9000), []) ;

  //style={{ ...props, top: "1px" , height: "500px" , backgroundImage: `url(https://images.unsplash.com/${item.url}&auto=format&fit=crop)` }}
  //<button onClick={() => set(!toggle)}>Toggle</button>
  //      <h1>
  /*Now: {count}
  <br />
  Before: {prevCount}
  </h1>*/

  //<button className = "click" onClick={() => setCount(count - 1)}>Increment</button>


  return (
    <>

<AbsoluteWrapper>
    <div className="">

    {transitions.map(({ item, props, key }) => (

    <div >
      
        <div className="main_container"   >
                {<animated.div
                key={key}
                className="login-slide"
                style={{ ...props, top: "1px" , marginLeft: '25%',  marginRight: '30%', height: "400px" , width : "55%",  backgroundImage: `url(${item.url}` }}

                />}
        </div>

    </div>
    
  ))}
        
                
          <div className = "vertical"></div> 

        <Cards1/>
        
        <Cards2/>
   
 


    

  </div>

  </AbsoluteWrapper>

    </>
  );
};

export default MainApp; 
